import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class IntegrationInterceptor implements HttpInterceptor {
  private getIntegrationValueFromLocalStorage(): string {
    const configValues = localStorage.getItem("generalconfig");

    if (configValues) {
      try {
        const parsed = JSON.parse(configValues);
        const entry = parsed.find(
          (item: any) => item.keyName === "IsThirdPartyIntegration"
        );
        if (entry && entry.keyValue) {
          return entry.keyValue;
        }
      } catch (e) {
        console.error("Error parsing generalconfig from localStorage", e);
      }
    }

    return "2"; // default fallback
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const integration = this.getIntegrationValueFromLocalStorage();

    const modifiedReq = req.clone({
      setHeaders: {
        "X-Integration-Type": integration,
      },
    });

    return next.handle(modifiedReq);
  }
}
